<main>
  <app-theme-list></app-theme-list>
</main>
<aside>
  <app-aside></app-aside>
</aside>